// Created by carsonaberle at 3/25/22
export const back = 'back';
export const forward = 'forward';
export const unmute = 'unmute';
export const mute = 'mute';
export const play = 'play';
export const pause = 'pause';
